import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { FilterSelect } from '~/pages/backoffice/TableToolbar'

type IProps = {
  count: number
  groups: readonly { id: string, name: string }[]
  groupId: string
  onGroupChange: (groupId: string) => void
  onApply: (action: 'add' | 'remove') => void
  onClear: () => void
}

/** Ajouter ou retirer d'un groupe les comptes cochés (#135). Rendue seulement s'il y en a. */
function BulkGroupBar({ count, groups, groupId, onGroupChange, onApply, onClear }: IProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-border bg-muted/50 p-3">
      <span className="text-sm font-medium">
        {t('groups.bulk.selected', { count })}
      </span>
      <FilterSelect
        value={groupId}
        onChange={e => onGroupChange(e.target.value)}
        aria-label={t('common.group')}
      >
        <option value="">{t('groups.select')}</option>
        {groups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
      </FilterSelect>
      <Button size="sm" disabled={!groupId} onClick={() => onApply('add')}>
        {t('groups.bulk.add')}
      </Button>
      <Button size="sm" variant="outline" disabled={!groupId} onClick={() => onApply('remove')}>
        {t('groups.bulk.remove')}
      </Button>
      <Button size="sm" variant="ghost" onClick={onClear}>
        {t('sessions.participants.clear')}
      </Button>
    </div>
  )
}

export default BulkGroupBar
